window.HealthReviewRevamp = (function ($) {
    const self = {
        urls: {
            PageUrl: '/Vitality-programme'            
        },
        func: {
            hide: function () {
                if (window.location.pathname === self.urls.PageUrl) {
                    $("#revamp").hide();
                }
                else {
                    $("#revamp").show();
                }
            },
            init: function () {
                self.func.hide();
            }
        }
    };
    return {
        Init: self.func.init
    };
})(jQuery);
$('document').ready(function () {
    if ('healthreviewrevamp' === $('#revamp').data('feature')) {
        this.HealthReviewRevamp.Init();
    }
});

